
define('jst!notifications/push/flash_notification',['underscore','translate'],function () { var _ = require('underscore');
var t = require('translate');
return _.template('<li class="notification flashmessage <%=style%>">\n  <div class="inner">\n    <div class="image-block message">\n      <div class="img icon">\n        <div class="<%=icon%>"></div>\n      </div>\n\n      <div class="bd text">\n        <h4 class="text-bold"><%- text %></h4>\n      </div>\n    </div>\n  </div>\n</li>\n');
 });

